import api from "./api";
export const getMerchants = async (params) => {
  return await api.get("/api/merchants", { params });
};
